var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    width: 128,
    height: 128,
    transform: "translate(687 6783)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "experience",
    transform: "translate(-687 -6783)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "experience-2",
    "data-name": "experience",
    transform: "translate(687 6783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14205",
    "data-name": "Path 14205",
    d: "M11.2,26.2A4.2,4.2,0,0,1,7,22V5.2a4.2,4.2,0,1,1,8.4,0V22A4.2,4.2,0,0,1,11.2,26.2Zm67.2,0A4.2,4.2,0,0,1,74.2,22V5.2a4.2,4.2,0,1,1,8.4,0V22A4.2,4.2,0,0,1,78.4,26.2Z",
    transform: "translate(19.2)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_541",
    "data-name": "Rectangle 541",
    width: 117.95,
    height: 100.985,
    rx: 2,
    transform: "translate(5.039 21.976)",
    fill: "#eef5fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14206",
    "data-name": "Path 14206",
    d: "M114.4,114.2H13.6A12.6,12.6,0,0,1,1,101.6v-84A12.6,12.6,0,0,1,13.6,5H114.4A12.6,12.6,0,0,1,127,17.6v84a12.6,12.6,0,0,1-12.6,12.6ZM13.6,13.4a4.2,4.2,0,0,0-4.2,4.2v84a4.2,4.2,0,0,0,4.2,4.2H114.4a4.2,4.2,0,0,0,4.2-4.2v-84a4.2,4.2,0,0,0-4.2-4.2Z",
    transform: "translate(0 12.8)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3310",
    "data-name": "Ellipse 3310",
    cx: 8.483,
    cy: 8.079,
    rx: 8.483,
    ry: 8.079,
    transform: "translate(22.005 13.897)",
    fill: "#ffc661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14207",
    "data-name": "Path 14207",
    d: "M17.6,28.2A12.6,12.6,0,1,1,30.2,15.6,12.6,12.6,0,0,1,17.6,28.2Zm0-16.8a4.2,4.2,0,1,0,4.2,4.2A4.2,4.2,0,0,0,17.6,11.4Z",
    transform: "translate(12.8 6.4)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3311",
    "data-name": "Ellipse 3311",
    cx: 8.483,
    cy: 8.079,
    rx: 8.483,
    ry: 8.079,
    transform: "translate(89.059 13.897)",
    fill: "#ffc661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14208",
    "data-name": "Path 14208",
    d: "M33.6,28.2A12.6,12.6,0,1,1,46.2,15.6,12.6,12.6,0,0,1,33.6,28.2Zm0-16.8a4.2,4.2,0,1,0,4.2,4.2A4.2,4.2,0,0,0,33.6,11.4Z",
    transform: "translate(64 6.4)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_542",
    "data-name": "Rectangle 542",
    width: 84.019,
    height: 58.975,
    rx: 1,
    transform: "translate(22.005 42.981)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14209",
    "data-name": "Path 14209",
    d: "M89,77.2H13.4A8.4,8.4,0,0,1,5,68.8V18.4A8.4,8.4,0,0,1,13.4,10H89a8.4,8.4,0,0,1,8.4,8.4V68.8A8.4,8.4,0,0,1,89,77.2ZM13.4,18.4V68.8H89V18.4Z",
    transform: "translate(12.8 28.8)",
    fill: "#6d6daa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.b4a8288d03774f8ee2214f36d34b92f3.svg";
export { ForwardRef as ReactComponent };